import { buttonReset } from '../../utils/helpers.styles';

export const styles = (theme) => {
  const {
    palette: {
      accent,
      background,
      highlightBackground,
      primary,
      text
    },
    spacing: { unit },
    typography
  } = theme;
  return ({
    controlBar: {
      display: 'flex',
      justifyContent: 'space-between',
      margin: [20, 0, 30, 0]
    },
    controlGroup: {
      ...buttonReset,
      display: 'flex'
    },
    controlIcon: {
      '& svg ': {
        fill: primary.normal
      },
      '&:hover': {
        '& svg': {
          fill: background
        },
        background: primary.normal
      },
      alignItems: 'center',
      borderRadius: 16,
      cursor: 'pointer',
      display: 'flex',
      height: 32,
      justifyContent: 'center',
      margin: [0, 2],
      padding: 0,
      width: 32
    },
    controls: {
      alignItems: 'center',
      display: 'flex',
      flex: '0 0 auto'
    },

    divider: {
      borderLeft: `2px solid ${accent}`,
      display: 'flex',
      height: 16,
      margin: [0, 15]
    },

    exportMenu: {
      '& :hover': {
        background: highlightBackground
      },
      '& li': {
        '&:last-child': {
          marginTop: 0
        },
        color: text.dark,
        fontSize: unit * 1.75,
        marginTop: 7,
        padding: [4, 0, 4, 8]
      },
      background,
      border: `1px solid ${accent}`,
      listStyleType: 'none',
      padding: [0, 0, 6, 0],
      position: 'absolute',
      right: 9,
      top: 16,
      width: 150,
      zIndex: 3
    },

    exportMenuContainer: {
      position: 'relative'
    },

    lastSyncIcon: {
      cursor: 'pointer',
      marginRight: 10
    },

    lastSyncWrapper: {
      display: 'flex'
    },
    preControls: {
      '& >:not(:first-child)': { paddingLeft: 10 },
      alignItems: 'center',
      display: 'flex',

      flex: '1 1 auto'
    },
    syncText: {
      color: text.dark,
      fontFamily: typography.fontFamily,
      fontSize: unit * 1.5,
      margin: '0 10px 0 0'
    }

  });
};

export default styles;
